var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.432,
    height: 57.468,
    viewBox: "0 0 56.432 57.468",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f2c80e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.366)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.366)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M31.713,0c-.015.015-.046.015-.092.015A28.192,28.192,0,0,0,9.51,45.777L5.4,55.323a1.532,1.532,0,0,0,.8,2.017,1.565,1.565,0,0,0,.878.108L22.151,54.8a27.165,27.165,0,0,0,9.392,1.632A28.216,28.216,0,0,0,31.713,0Zm-.154,53.368a24.716,24.716,0,0,1-8.7-1.586,1.476,1.476,0,0,0-.816-.077L9.356,53.922l3.357-7.807a1.548,1.548,0,0,0-.246-1.617,24.616,24.616,0,0,1-4.28-7.114,25.14,25.14,0,1,1,48.548-9.3v.092A25.207,25.207,0,0,1,31.559,53.368Z",
    transform: "translate(-3.366)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.503 22.588)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M124.52,146.7h-8.315a1.54,1.54,0,1,0,0,3.079h8.315a1.54,1.54,0,1,0,0-3.079Z",
    transform: "translate(-114.666 -146.7)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.503 30.287)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M135.3,196.7H116.206a1.54,1.54,0,0,0,0,3.079H135.3a1.54,1.54,0,0,0,0-3.079Z",
    transform: "translate(-114.666 -196.7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.6eff79cc7a9f2a057ef7c59c5a4244c0.svg";
export { ForwardRef as ReactComponent };